import React, {useState, useRef} from 'react';
import {message, Modal, Row} from 'antd';
import './style.module.css';
import ButtonComponent from '../../../atoms/Buttons';
import GeneralModal, {GeneralModalRef} from '../../../molecules/Modals/general/component';
import SetPasswordForm from '../../../molecules/Forms/SetPassword/component';
import authService from '../../../../services/authService';
import {useNavigate} from 'react-router-dom';
import {removeCookie} from 'typescript-cookie';
import * as authActions from '../../../../store/modules/auth/actions';
import {useDispatch} from 'react-redux';
import {validatePassword} from '../../../../utils/validators';
import {UserObject} from '../../../../utils/types';

type FormProps = {
    visible: boolean;
    onClose: () => void;
    item?: UserObject | null;
    email: string
};

const SetPasswordDialog = ({visible, onClose, email}: FormProps) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const generalModalRef = useRef<GeneralModalRef>(null)
    const searchParams = new URLSearchParams(window.location.search);
    const caseValue = searchParams.get('type');
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [required, setRequired] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState(true);
    const [passwordValid, setPasswordValid] = useState(true);
    const [passwordErrors, setPasswordErrors] = useState<string[]>([]);

    const handleOk = async (event: React.FormEvent) => {
        event.preventDefault();
    };

    const handleCancel = async () => {
        onClose();
        navigate('/');
    };

    const handlePasswordChange = (value: string) => {
        setPassword(value);
        const result = validatePassword(value);
        setPasswordValid(result.valid);
        setPasswordErrors(result.errors);

        if (repeatPassword) {
            setPasswordMatch(value === repeatPassword);
        }
    };


    const handleRepeatPasswordChange = (repeatPassword: string) => {
        setRepeatPassword(repeatPassword);

        if (password === repeatPassword) {
            setPasswordMatch(true);
        } else {
            setPasswordMatch(false);
        }
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setRequired(true);

        const match = password && repeatPassword && password === repeatPassword;
        setPasswordMatch(!!match);

        if (!password || !repeatPassword) {
            message.error('Please fill in both password fields.');
            return;
        }

        if (!passwordValid) {
            message.error('Please fix the password requirements.');
            return;
        }

        if (!match) {
            message.error('Passwords do not match.');
            return;
        }

        try {
            let result;

            if (caseValue == 'verification') {
                result = await authService.setPassword({password: password, email: email});
            } else if (caseValue == 'resetPassword') {
                if (token) result = await authService.resetPassword({newPassword: password, token: token});
            }

            if (result?.status === 200) {
                removeCookie('token', {path: '/'});
                removeCookie('roleType', {path: '/'});

                dispatch(authActions.logoutSuccess());
                navigate('/');
                message.success('Password set successfully. You can now log in.');
            }
        } catch (error: any) {
            if (generalModalRef.current) {
                message.error(error?.response?.data?.message);
            }
        }
    };

    return (
        <Modal open={true} onCancel={handleCancel} onOk={handleOk} centered maskClosable={false} width={420}
               footer={[
                   <ButtonComponent key={'create-button'} onClick={handleSubmit} label={'Set password'}
                                    buttonType={'primary'}/>
               ]}
        >
            <Row className={'setPasswordForm'}>
                <SetPasswordForm password={password} repeatPassword={repeatPassword} required={required}
                                 onPasswordChange={handlePasswordChange}
                                 onRepeatPasswordChange={handleRepeatPasswordChange} passwordMatch={passwordMatch}
                                 passwordValid={passwordValid} passwordErrors={passwordErrors} onSubmit={handleSubmit}/>
            </Row>
            <GeneralModal ref={generalModalRef}/>
        </Modal>
    );
};

export default SetPasswordDialog;